import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Flex, Row, Col, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import DefineStructure from "./DefineStructure";
import Structure from "./Structure";
import { HomeOutlined, PlusOutlined } from "@ant-design/icons";
import BreadCrumb from "../BreadCrumb";
import { getUserSpaceEntitlements } from "../../utils/currentUserDetail";

const { Title } = Typography;


const OrganisationChartPage = () => {
    // const organisationData = useLoaderData();
    const { t } = useTranslation();
    let defaultBreadCrumbItems = [{ title: <HomeOutlined />, path: "/app/dashboard" }, { title: t('Admin'), path: "/app/admin/config" }, { title: t('Organisation Structure') }]
    const [showAddStructure, setShowAddStructure] = useState(false)
    const [breadCrumbItems, setBreadCrumbItems] = useState(defaultBreadCrumbItems);
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("define");
    let currentSearchParams = searchParams.get("tab");
    const { userInfo } = useSelector(state => state.user);
    const adminEntitlements = getUserSpaceEntitlements(null, userInfo.userAccess);

    const handleAddBtn = () => {
        setShowAddStructure(!showAddStructure)
    }
    const defaultTabs = [
        {
            key: "define-structure",
            label: t("Define Structure"),
            children: <DefineStructure adminEntitlements={adminEntitlements} />,
        },
        {
            key: "structure",
            label: t("Structure"),
            children: <Structure showAddStructure={showAddStructure} handleAddBtn={handleAddBtn} adminEntitlements={adminEntitlements} />,
        }
    ];



    useEffect(() => {

        if (currentSearchParams) {
            let tabItem = defaultTabs.find(item => item.key === currentSearchParams);
            if (tabItem) {
                let newItem = { title: tabItem.label, path: "" }
                setBreadCrumbItems([...defaultBreadCrumbItems, newItem])
            }
        }
    }, [searchParams])

    const onChangeTab = (value) => {
        // setSearchParams({ tab: value });
        setShowAddStructure(false)
        setActiveTab(value)
    }

    return (
        <div className="page-wrapper admin-config">
            <BreadCrumb items={breadCrumbItems} marginb="16px" />
            <Row
                gutter={8}
                style={{
                    margin: "0 0 8px 0",
                    paddingBottom: "8px"
                }}
            >
                <Col span={12}>
                    <Title level={4} style={{ margin: 0 }}>
                        {t("Organisation Structure")}
                    </Title>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                    {
                        currentSearchParams === 'structure' && adminEntitlements.includes("Organisation_Structure_Update") &&
                        <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowAddStructure(true)}>
                            {t("Add Component")}
                        </Button>
                    }
                </Col>
            </Row>
            <Flex align="center" justify="space-between" style={{ display: "flex", background: "#eeeef0", maxWidth: "fit-content", borderRadius: "0.375rem", padding: "0.25rem" }}>
                <div className="cursor-pointer widget-tab" style={{ background: activeTab == "define" ? "#fff" : "#eeeef0", width: "fit-content" }} onClick={() => onChangeTab("define")}>{t("Define Structure")}</div>
                <div className="cursor-pointer widget-tab" style={{ background: activeTab == "structure" ? "#fff" : "#eeeef0" }} onClick={() => onChangeTab("structure")}>{t("Structure")}</div>
            </Flex>
            {
                activeTab === "define" ?
                    <DefineStructure adminEntitlements={adminEntitlements} /> :
                    <Structure showAddStructure={showAddStructure} handleAddBtn={handleAddBtn} adminEntitlements={adminEntitlements} />
            }
            {/* <div style={headerActionStyle}>
                <Space>
                    {getActions(activeTab)}
                </Space>
            </div> */}
            {/* <div style={{ margin: "0" }}>
                <Tabs items={defaultTabs} onChange={onChangeTab}></Tabs>
            </div> */}
        </div>
    )
}

export default OrganisationChartPage